<template>
  <div class="w-50 p-3 mx-auto mt-4">
    <h1 class="mt-5 mb-4 text-center">
      Ajouter une nouvelle catégorie MIRAKL
    </h1>
    <b-card>
      <b-form @submit.prevent="onSubmit">
        <b-card-body>
          <ValidationProvider rules="required" v-slot="validationContext">
            <b-form-group
              label-cols="7"
              label-cols-lg="5"
              label-size="small"
              label="Catégorie MIRAKL parente"
              label-for="input-autoComplete"
            >
              <gwzAutoComplete
                id="input-autoComplete"
                :http="httpMirakl"
                v-model="form.hierarchyParentCode"
                labelName="hierarchyLabel"
                queryParamName="hierarchyLabel"
                nameEndpoint="listMirakl"
                placeholder="Rechercher une catégorie MIRAKL"
                @response="AddCodeParent"
                :state="getValidationState(validationContext)"
                aria-describedby="email-input-live-feedback"
              ></gwzAutoComplete>
              <b-form-invalid-feedback id="email-input-live-feedback">{{
                validationContext.errors[0]
              }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
          <ValidationProvider rules="required" v-slot="validationContext">
            <b-form-group
              label-cols="7"
              label-cols-lg="5"
              label-size="small"
              label="Label catégorie MIRAKL"
              label-for="input-label"
            >
              <b-form-input
                id="input-label"
                placeholder="Ajoute une catégorie MIRAKL"
                v-model="form.hierarchyLabel"
                :state="getValidationState(validationContext)"
                aria-describedby="categories-mirakl-feedback"
                required
              ></b-form-input>
              <b-form-invalid-feedback id="categories-mirakl-feedback">{{
                validationContext.errors[0]
              }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
          <ValidationProvider rules="required" v-slot="validationContext">
            <b-form-group
              label-cols="7"
              label-cols-lg="5"
              label-size="small"
              label="Code catégorie MIRAKL"
              label-for="input-code"
            >
              <b-form-input
                id="input-code"
                placeholder="Ajoute un code MIRAKL"
                :state="getValidationState(validationContext)"
                v-model="form.hierarchyCode"
                aria-describedby="code-mirakl-feedback"
                required
              ></b-form-input>
              <b-form-invalid-feedback id="code-input-live-feedback">{{
                validationContext.errors[0]
              }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
        </b-card-body>
        <div class="text-right">
          <gwz-button submitButtonText="Enregistrer" />
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import gwzAutoComplete from "@/components/gwzAutoComplete";
import { required } from "vee-validate/dist/rules";
import { extend, ValidationProvider } from "vee-validate";
import { mapGetters, mapActions } from "vuex";
import GwzButton from "@/components/gwzButton";

extend("required", {
  ...required,
  message: "Ce champ est obligatoire"
});
export default {
  name: "AddCategories",
  components: {
    GwzButton,
    gwzAutoComplete,
    ValidationProvider
  },
  data() {
    return {
      httpMirakl: this.$gwzApi.service("categories"),
      iris: "",
      form: {
        hierarchyParentCode: "",
        hierarchyCode: "",
        hierarchyLabel: ""
      },
      categoriesId: 0,
      validationContext: {}
    };
  },
  computed: {
    ...mapGetters(["isError"])
  },
  methods: {
    ...mapActions(["setErrors"]),
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    AddCodeParent(category) {
      this.iris = category?.["@id"];
      this.categoriesId = category?.id;
    },
    async onSubmit() {
      this.form.hierarchyParentCode = this.iris;
      this.removeEmptyProperties(this.form);
      await this.$store.dispatch("categories/addMiraklCategory", this.form);
      (await this.isError)
        ? this.reset()
        : this.$router.push({ name: "Categories" });
    },
    reset() {
      let form = {
        hierarchyParentCode: "",
        hierarchyCode: "",
        hierarchyLabel: ""
      };
      this.$set(this, "form", form);
      this.setErrors(false);
    },
    removeEmptyProperties(obj) {
      return Object.keys(obj).forEach(key => {
        if (obj[key] === "") {
          delete obj[key];
        }
      });
    }
  }
};
</script>

<style scoped>
label {
  justify-content: left !important;
}
</style>
